const subscriptions = {
  moduleTitle: "Subscriptions",
  actions: {
    view: "View subscriptions",
    create: "Create subscription",
    update: "Update subscription",
    delete: "Delete subscription",
  },
  permissions: {
    core: "Core",
    management: "Subscription management",
    subscriptions: "Subscriptions",
  },
  listTitle: "Subscriptions",
  listSubtitle: "Manage vendor subscriptions for companies",
  create: "Create subscription",
  filters: {
    title: "Subscription filters",
    filters: "Filters",
    search: "Search subscriptions",
    searchPlaceholder: "Search by subscriber",
    subscriber: "Subscriber",
    subscriberPlaceholder: "All subscribers",
    subscriberSearch: "Find a subscriber",
    subscriberEmpty: "No subscribers found.",
    clearSubscriber: "Clear subscriber",
    status: "Status",
    allStatuses: "All statuses",
    activeOnly: "Active only",
    createdAt: "Created at",
    createdAtPlaceholder: "Select a date range",
    clearDateRange: "Clear date range",
  },
  datePicker: {
    nextMonth: "Next month",
    previousMonth: "Previous month",
  },
  table: {
    subscriber: "Subscriber",
    modules: "Modules",
    moreModules: "{{count}} more modules",
    totalPrice: "Total price",
    status: "Status",
    createdAt: "Created",
    actions: "Actions",
    empty: "No subscriptions match these filters.",
    error: "Subscriptions could not be loaded.",
    loading: "Loading subscriptions",
    showing: "Showing {{count}} of {{total}}",
    rowsPerPageLabel: "Rows per page",
    next: "Next page",
    previous: "Previous page",
    pagination: "Pagination",
    sortAscending: "Sort ascending",
    sortDescending: "Sort descending",
  },
  status: {
    active: "Active",
    inactive: "Inactive",
    expired: "Expired",
    scheduled: "Scheduled",
  },
  actionMenu: {
    trigger: "Subscription actions",
    view: "View details",
  },
  form: {
    createTitle: "Create subscription",
    backToDetail: "Back to subscription",
    addModulesTitle: "Add modules",
    createSuccess: "Subscription created successfully.",
    updateSuccess: "Subscription updated successfully.",
    subtitle: "Select the subscriber and module details.",
    catalogUnavailable:
      "The catalog module is unavailable, so modules cannot be added.",
    companiesUnavailable:
      "The companies module is unavailable, so subscribers cannot be selected.",
    subscriberId: "Subscriber",
    selectInstitution: "Select institution",
    subscriberPlaceholder: "Select institution",
    featureId: "Module",
    modulePlaceholder: "Module ID",
    purchasingPrice: "Purchasing price",
    noPeriod: "No period (never expires)",
    dateRange: "Subscription period",
    dateRangePlaceholder: "Select start and end dates",
    selectDatePlaceholder: "Select date",
    clearDateRange: "Clear date range",
    nextMonth: "Next month",
    previousMonth: "Previous month",
    deviceTypes: "Device types",
    deviceTypesSubtitle:
      "Add the device types this institution is authorized to use under this contract.",
    systemsSubtitle:
      "Choose the modules included in this subscription. Prices can be adjusted as needed.",
    currentModules: "Current modules",
    currentModulesSubtitle:
      "Modules already on this subscription. They're shown for reference and can't be edited here.",
    assignableSubtitle:
      "Only modules not yet on this subscription can be added.",
    noAssignableModules:
      "There are no modules available to add to this subscription.",
    addDeviceType: "Add device type",
    removeDeviceType: "Remove device type",
    modulesRequired: "At least one module must be selected.",
    capacity: {
      label: "{{name}} capacity",
      total: "Total count",
      used: "Used count",
      remaining: "Remaining count",
      unlimited:
        "The capacity of this system is unlimited, and you can add users without consuming or affecting the allocated capacity.",
    },
    save: "Save",
    cancel: "Cancel",
  },
  detail: {
    loading: "Loading subscription",
    backToList: "Back to subscriptions",
    error: "Subscription could not be loaded.",
    modules: "Modules",
    purchasingPrice: "Purchasing price",
    price: "Price",
    addFeatures: "Add modules",
    subtitle:
      "Create the subscription and set the institution's license limits",
    edit: "Edit",
    tabs: {
      upcoming: "Upcoming",
      current: "Current",
      previous: "Previous",
    },
    companyDetails: "Company details",
    institutionName: "Institution name",
    devices: "Devices",
    deviceType: "Device type",
    deviceModel: "Device model",
    quantity: "Quantity",
    duration: "Duration",
    noDevices: "No devices allocated to this subscription.",
    systems: "Systems",
    startDate: "Start date",
    endDate: "End date",
    noModules: "No modules in this category.",
  },
  duration: {
    annual: "Annual",
    semiAnnual: "Half-Annual",
    monthly: "Monthly",
    days: "{{count}} days",
    noPeriod: "No period",
  },
  validation: {
    required: "This field is required.",
    price: "Enter a valid non-negative price.",
    priceRequired: "A purchasing price is required for this module.",
    dateRange: "Select both a start date and an end date.",
    invalidPeriod: "The period must be exactly 1, 3, 6, 9, or 12 months.",
  },
};
export default subscriptions;
